module.exports = {
  url: process.env.NODE_ENV === 'development' ? 'https://api-drachei.herokuapp.com' : 'https://api.drachei.com.br',
  // url: 'https://api.drachei.com.br',
  // url: 'http://localhost:5000',
  urlPayment: process.env.NODE_ENV === 'development' ? 'https://powerdevs.minivps.info:3000' : 'https://payment.drachei.com.br',
  urlGrupoSin: process.env.NODE_ENV === 'development' ? 'https://portal-grupo-sin-stage.herokuapp.com' : 'https://api.sinsaudecard.com.br',
  // urlGrupoSin: 'https://api.sinsaudecard.com.br'
}



// WEBPACK FOOTER //
// ./src/endpoint.js